import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAIz2GttoVuFFhoUe_OY68VJRtsArKGaRE",
  authDomain: "becx-eb075.firebaseapp.com",
  projectId: "becx-eb075",
  storageBucket: "becx-eb075.firebasestorage.app",
  messagingSenderId: "916200437927",
  appId: "1:916200437927:web:e126d31c76e508ffc14382"
};

// Initialize Firebase and Firebase Authentication
const app = initializeApp(firebaseConfig);
console.log(app)
const auth = getAuth(app);
// const analytics = getAnalytics(app);
const db = getFirestore(app);
console.log(auth)
export { auth, db,
  
  // analytics 
};
